import React from "react";
import { useSiteMetadata } from "../hooks/useSiteMetadata";

const Seo = (props) => {
  const data = useSiteMetadata();
  console.log("image", data);
  console.log("props.pathname", props.pathname);
  const seo = data.siteMenu.find((item) => props.pathname === item.link);
  const url = `${data.siteUrl}${seo.link || ``}`;

  return (
    <>
      <title>{seo.title}</title>

      <meta name="description" content={seo.description} />
      <meta name="image" content={data.image} />
      <meta property="og:title" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={data.siteUrl} />
      <meta property="og:image" content={data.image} />
      {/* list other social meta tags here */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={data.image} />
      {props.children}
    </>
  );
};

export default Seo;
